module.exports = __webpack_public_path__ + "fonts/Inter-900-latin84.260c81a.woff2";